import {
   AscSortIcon,
   CommentsIcon,
   DescSortIcon,
   DownArrow,
   DummyImage,
   EditIcon,
   FilterClearIcon,
   LikeIcon,
   ShortIcon,
   UpArrowIcon
} from 'assets'
import { DropDown } from 'components'
import dayjs from 'dayjs'
import { useOutsideClick } from 'Hooks'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { getCommentListAction, loadMoreCommentsAction } from 'store/action/videoReducer'
import { formatNumber } from 'utils/formatNumber'
import { getEmotionIcon } from 'utils/getEmotionIcon'
import { getSentimentIcon } from 'utils/getSentimentIcon'
import { removeUtcFormate } from 'utils/removeUtcFormate'

const sentimentConstOpt = [
   {
      label: 'All',
      value: 'All'
   },
   {
      label: 'Positive',
      value: 'positive'
   },
   {
      label: 'Negative',
      value: 'negative'
   },
   {
      label: 'Neutral',
      value: 'neutral'
   }
]

const sortTypeConstOpt = [
   {
      label: 'All',
      value: 'All'
   },
   {
      label: 'Comment Likes',
      value: 'comment_likes'
   },
   {
      label: 'Replies Count',
      value: 'replies_count'
   },
   {
      label: 'published At',
      value: 'published_at'
   }
]

function DComments() {
   const dispatch = useDispatch()
   const videoRedux = useSelector((state) => state.videoRedux)
   const {
      videoDetails,
      commentList,
      loadMoreComments,
      isNextCommentPage,
      videoDetailsLoader,
      loadingComment,
      loadMoreCommentsLoading
   } = videoRedux
   const settingData = useSelector((state) => state.settings)
   const { selectedChannelID } = settingData
   const [commentData, setCommentData] = useState(null)
   const param = useParams()

   useEffect(() => {
      if (videoDetails) {
         if (commentList && commentList?.length && !loadingComment) {
            if (commentData?.length > 0) {
               setCommentData((prevItems) => {
                  const combinedItems = [...prevItems, ...commentList]
                  // Remove duplicates based on a unique property, assuming `id` is unique
                  const uniqueItems = Array.from(
                     new Map(combinedItems.map((item) => [item.comment_id, item])).values()
                  )
                  return uniqueItems
               })
            } else {
               setCommentData(commentList)
            }
         } else {
            setCommentData([])
         }
      } else {
         setCommentData([])
      }
      return () => {}
   }, [commentList, videoDetails])

   const getCommentList = (page_number, s_name, sort_type) => {
      dispatch(
         getCommentListAction({
            video_id: param?.id,
            channel_id: selectedChannelID,
            page: page_number || 1,
            sort_by: sort_type !== 'All' ? sort_type : '',
            sentiment: s_name !== 'All' ? s_name : ''
         })
      )
   }

   useEffect(() => {
      if (videoDetails?.video_id && selectedChannelID && !videoDetailsLoader) {
         getCommentList(1, '', '')
      }
      return () => {}
   }, [videoDetails?.video_id, videoDetails, videoDetailsLoader])

   return (
      <div className="card comment-section-wrap">
         <div className="comment-section atenya-ai-section">
            <div className="atenya-ai-title-section">
               <div className=" atenya-ai-title-wrap">
                  <h2 className="at-text-dark mb-0">Comments</h2>
                  <p className="at-text-light video-comments">
                     {videoDetails?.comment_count || 0} comments posted ·{' '}
                     <span className="video-comments-analysis">
                        {videoDetails?.total_analyzed_comments || 0} analyzed{' '}
                     </span>
                  </p>
                  {/* <p className="at-text-light">Here's a quick breakdown of the feedback:</p> */}
               </div>
            </div>
         </div>
         <div className="comment-wrap">
            {!loadMoreCommentsLoading &&
               commentData &&
               commentData?.length > 0 &&
               commentData?.map((item, i) => {
                  return (
                     <div className="mt-3" key={i}>
                        <CommentCard item={item} />
                     </div>
                  )
               })}
            {(loadingComment || loadMoreCommentsLoading) &&
               [...Array(3)].map((_, index) => (
                  <div key={index} className="card comment-card mt-3 p-0">
                     <div className="card_sk">
                        <div className="card__title loading"></div>
                        <div className="card__title loading"></div>
                        <div className="card__title loading"></div>
                     </div>
                  </div>
               ))}
         </div>
      </div>
   )
}

export default DComments

const CommentCard = ({ item }) => {
   return (
      <div className="card comment-card">
         <div className="comment-card-border"></div>
         <div className="comment-details">
            <div className="comment-name-section">
               <div className="name-image-section">
                  <img src={DummyImage} alt="user" />
                  <div className="name-date-wrap">
                     <span>{item?.author_name} </span>
                     <div>
                        <span className="at-text-light">
                           {' '}
                           {item?.published_at
                              ? dayjs(removeUtcFormate(item?.published_at)).format('D MMMM, YYYY')
                              : ''}
                        </span>{' '}
                        {item?.is_edited && (
                           <>
                              ·<span className="edited-text"> Edited</span>{' '}
                           </>
                        )}
                     </div>
                  </div>
               </div>
               <div className="filter">
                  <div className="comment-icon-wrap">
                     <div className="comment-icon-section">
                        <div className="comment-icon">{getSentimentIcon(item?.sentiment)}</div>
                        <span className="text-capitalize">{item?.sentiment}</span>
                     </div>
                     <div className="comment-icon-section">
                        <div className="comment-icon comment-emotion-icon">
                           {getEmotionIcon(item?.emotion, item?.sentiment)}
                        </div>
                        <span className="text-capitalize">{item?.emotion}</span>
                     </div>
                  </div>
               </div>
            </div>
            <div className="comment-content">{item?.text}</div>
            <div className="comment-count video-icon mt-3">
               <div className="d-flex align-items-center gap-2 video-icon-wrap">
                  <div className="at-video-icon">
                     <LikeIcon />
                  </div>
                  <span className=" at-text-light video-counter">
                     {formatNumber(item?.comment_likes || 0, 2)}
                  </span>
               </div>
               <div className="d-flex align-items-center gap-2 video-icon-wrap">
                  <div className="at-video-icon">
                     <CommentsIcon />
                  </div>
                  <span className=" at-text-light video-counter">
                     {' '}
                     {formatNumber(item?.num_replies || 0, 2)}
                  </span>
               </div>
            </div>
         </div>
      </div>
   )
}

const CommentListSortFilter = ({
   setSortOpenFilter,
   sortOpenFilter,
   onChangeSortType,
   sortType
}) => {
   const sortTypeRef = useOutsideClick(() => setSortOpenFilter(false))

   return (
      <div className="at-dropdown-filer-wrap at-sort" ref={sortTypeRef}>
         <div
            className="owner-logo-section add-border videos-filter-icon"
            onClick={() => {
               setSortOpenFilter(!sortOpenFilter)
            }}
            title="Sort By">
            <ShortIcon />
            {sortType.label !== 'All' && <div className="active-dot"></div>}
         </div>
         {sortOpenFilter && (
            <ul className="at-list-opt mobile-at-list-opt">
               <li
                  onClick={() => {
                     onChangeSortType('All', '')
                  }}>
                  <div className="at-list-wrap">
                     <span className="at-opt-name">All</span>
                     <span className={`at-opt-pin ${sortType.label === 'All' ? 'active' : ''}`}>
                        <span className="w-dot"></span>
                     </span>
                  </div>
               </li>

               <CommentSortItemLi
                  onChangeSortType={onChangeSortType}
                  sortType={sortType}
                  label={'Comment Likes'}
                  value={'comment_likes'}
               />
               <CommentSortItemLi
                  onChangeSortType={onChangeSortType}
                  sortType={sortType}
                  label={'Replies Count'}
                  value={'replies_count'}
               />
               <CommentSortItemLi
                  onChangeSortType={onChangeSortType}
                  sortType={sortType}
                  label={'Published At'}
                  value={'published_at'}
               />
            </ul>
         )}
      </div>
   )
}

const CommentSortItemLi = ({ onChangeSortType, sortType, label, value }) => {
   return (
      <li
         onClick={() => {
            if (sortType.or_type === 'asc') {
               onChangeSortType(value, 'desc')
            } else if (sortType.or_type === 'desc') {
               onChangeSortType(`-${value}`, 'asc')
            } else {
               onChangeSortType(value, 'desc')
            }
         }}>
         <div className="at-list-wrap">
            <span className="at-opt-name">{label}</span>
            <div className="sort-dot-icon">
               {sortType?.label === value || sortType.label === `-${value}` ? (
                  sortType.or_type === 'asc' ? (
                     <DescSortIcon />
                  ) : sortType.or_type === 'desc' ? (
                     <AscSortIcon />
                  ) : (
                     <ShortIcon />
                  )
               ) : (
                  <ShortIcon />
               )}

               <span
                  className={`at-opt-pin ${
                     sortType.label === value || sortType.label === `-${value}` ? 'active' : ''
                  }`}>
                  <span className="w-dot"></span>
               </span>
            </div>
         </div>
      </li>
   )
}
